import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { AutoSizer, Column, Table } from 'react-virtualized';
import { StatusIconCell, DateCell } from './CellFormatters.react';
import { ScenarioPropTypes } from '../util/helpers/SharedPropTypes';

const selectScenario = (savedScenarioId, router) => {
  router.push(`/crosschannel/${savedScenarioId}`);
};

const ScenarioTable = ({ scenarios, title }, context) => (
  <div className='scenario-table'>
    <AutoSizer disableHeight>
      {({ width }) => (
        <Table
          height={48 + (50 * scenarios.size)}
          width={width}
          rowGetter={({ index }) => scenarios.toArray()[index]}
          rowCount={scenarios.size}
          rowHeight={50}
          headerHeight={50}
          className='mainTable'
          onRowClick={({ index }) => selectScenario(scenarios.toArray()[index].id, context.router)}
        >
          <Column
            width={50}
            label=''
            flexShrink={0}
            dataKey='status'
            cellRenderer={StatusIconCell}
          />
          <Column
            width={200}
            flexGrow={1}
            label='Name'
            dataKey='name'
          />

          {
            title !== 'Draft' &&
            <Column
              width={250}
              label='Last Run'
              dataKey='lastRun'
              cellDataGetter={
                ({ rowData }) => (rowData.lastRun || {}).startedAt
              }
              flexShrink={1}
              cellRenderer={DateCell}
            />
          }
        </Table>
      )}
    </AutoSizer>
  </div>
);

ScenarioTable.propTypes = {
  title: PropTypes.string,
  scenarios: ImmutablePropTypes.iterableOf(ScenarioPropTypes),
};

ScenarioTable.contextTypes = {
  router: PropTypes.object,
};

export default ScenarioTable;
